import { createFormContext } from '@mantine/form'

export interface ResetPasswordFormData {
  email: string
}

export const [ResetPasswordFormProvider, useResetPasswordFormContext, useResetPasswordForm] = createFormContext<ResetPasswordFormData>()